import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "./recognised-courts.scss";
import "./approved-products.scss";
import { makeAccordion } from "./utils";
import loadLightbox, { open } from "../Lightbox/src";
import { TTImageCarousel } from "../../dynamic/TennisTech/TTImageCarousel";
import { imageData } from "./mockdata";

interface ImgData {
  imageUrl: string;
  title: string;
}

export const ApprovedProductsInit = (imageData: ImgData[]) => {
  makeAccordion("approved-products__title");

  // lightbox
  loadLightbox({
    elClassName: "lightbox-products",
    lightboxDialogClassName: "lightbox-products__inner"
  });

  let elementsTab: HTMLElement[] | null = Array.from(
    document.querySelectorAll(
      `.approved-products .approved-products__tablet-table-cell img`
    )
  );

  if (elementsTab !== null) {
    elementsTab.map((el: HTMLElement, index) => {
      el.addEventListener(
        "click",
        open.bind(null, {
          func: () => {
            if (document.querySelector(".lightbox-products__inner") !== null) {
              ReactDOM.unmountComponentAtNode(
                document.querySelector(".lightbox-products__inner")!
              );
            }

            ReactDOM.render(
              <TTImageCarousel items={imageData} index={index} />,
              document.querySelector(".lightbox-products__inner")
            );
          },
          className: "lightbox-products"
        })
      );
    });
  }

  let elementsMob: HTMLElement[] | null = Array.from(
    document.querySelectorAll(
      `.approved-products .approved-products__non-tablet-table-cell img`
    )
  );

  if (elementsMob !== null) {
    elementsMob.map((el: HTMLElement, index) => {
      el.addEventListener(
        "click",
        open.bind(null, {
          func: () => {
            if (document.querySelector(".lightbox-products__inner") !== null) {
              ReactDOM.unmountComponentAtNode(
                document.querySelector(".lightbox-products__inner")!
              );
            }

            ReactDOM.render(
              <TTImageCarousel items={imageData} index={index} />,
              document.querySelector(".lightbox-products__inner")
            );
          },
          className: "lightbox-products"
        })
      );
    });
  }
};

const ApprovedProducts = () => {
  useEffect(() => {
    ApprovedProductsInit(imageData);
  }, []);

  return (
    <div className="approved-products">
      <div className="approved-products__apply-link">
        <a className="btn">Apply for pat product</a>
      </div>
      <div className="accreditation-table-wrapper">
        <table className="accreditation-table accreditation-table--responsive">
          <thead>
            <tr>
              <th>
                <span>Product</span>
              </th>
              <th className="approved-products__desktop-table-cell">
                <span>Company</span>
              </th>
              <th>
                <span>Report</span>
              </th>
              <th>
                <span>Certificate</span>
              </th>
              <th>
                <span>Issue date</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {[0, 1, 2, 3, 4].map(value => {
              return (
                <tr>
                  <td className="approved-products__title">
                    <span>
                      <strong>Artengo Personal Coach {value}</strong>
                    </span>
                    <button className={`accordion__toggle-btn`} />
                  </td>
                  <td className="approved-products__non-tablet-table-cell">
                    <span className="approved-products__mobile-details">
                      <span className="approved-products__mobile-address-details">
                        <img src="../../assets/images/racket.png" />
                        <span className="accreditation-table__vertical approved-products__address">
                          <span className="approved-products__non-desktop-flex">
                            <span className="accreditation-table__column accreditation-table__column--light">
                              <strong>Artengo</strong>
                              <a target="_blank" href="#0">
                                artengo.com
                              </a>
                              <span>eric.briet@oxylane.com</span>
                              <strong>Issue date: 10 May 2014</strong>
                            </span>
                          </span>
                        </span>
                      </span>
                      <span className="approved-products__tech-file tech-files__list-item--pdf">
                        <a href="#0">PAT Approval Report</a>
                      </span>
                      <span className="approved-products__tech-file tech-files__list-item--pdf">
                        <a href="#0">PAT Approval Report</a>
                      </span>
                    </span>
                  </td>
                  <td className="approved-products__tablet-table-cell">
                    <span className="accreditation-table__product">
                      <img src="../../assets/images/racket.png" />
                      <span className="accreditation-table__vertical approved-products__address">
                        <strong>Artengo Personal Coach {value}</strong>
                        <span className="approved-products__non-desktop-flex">
                          <span className="accreditation-table__column accreditation-table__column--light">
                            <strong>Artengo</strong>
                            <span>artengo.com</span>
                            <span>eric.briet@oxylane.com</span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </td>
                  <td className="approved-products__desktop-table-cell">
                    <span className="accreditation-table__column accreditation-table__column--light">
                      <strong>Artengo</strong>
                      <span>artengo.com</span>
                      <span>eric.briet@oxylane.com</span>
                    </span>
                  </td>
                  <td className="approved-products__tablet-table-cell">
                    <span className="approved-products__tech-file tech-files__list-item--pdf">
                      <a href="#0">PAT Approval Report</a>
                    </span>
                  </td>
                  <td className="approved-products__tablet-table-cell">
                    <span className="approved-products__tech-file tech-files__list-item--pdf">
                      <a href="#0">PAT Approval Certificate</a>
                    </span>
                  </td>
                  <td className="approved-products__tablet-table-cell">
                    <span>10 May 2014</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ApprovedProducts;
